import React from 'react';

export const TitleCard = ({children}) =>{
    return <div className='font-bold text-lg xl:text-5xl 2xl:text-6xl dark:text-white'>{children}</div>
}

export const DescriptionCard = ({children}) =>{
    return <div className='text-sm xl:text-2xl 2xl:text-3xl text-stone-700 dark:text-stone-100'>
        {children}
    </div>
}

export const ListSection = ({title, description, children}) =>{
    return(
        <div className='mt-4 bg-stone-100 dark:bg-stone-600'>
            <div className='w-full px-6 xl:px-20 2xl:px-40 py-3 xl:py-8 2xl:py-10'>
                <TitleCard>{title}</TitleCard>
                <DescriptionCard>{description}</DescriptionCard>
                    {children}
            </div>
        </div>
    )
}
